module.exports = __webpack_public_path__ + "static/img/T73852.947357fd.png";